import * as Redux from 'redux'
import { connect } from 'react-redux'
import { Grid } from '@mui/material'
import clsx from 'clsx'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import React, { ChangeEvent, useEffect } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { APIServices } from '@Services/api.service'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import RegroundAction from '@ClientActions/reground.action'
import { EducatorActionTypes } from '@EducatorStores/educator.action-types'
import EducatorInfoActions from '@EducatorActions/educator-info.action'
import { MCity, RegroundTypes } from '@Models/auth.model'
import { ICommonQuery, ISelectOptions } from '@Models/common.model'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import InputMask from 'react-input-mask'

const relationshipOptions: ISelectOptions[] = [
    {
        name: 'Parent',
        value: 'Parent',
    },
    {
        name: 'Guardian',
        value: 'Guardian',
    },
    {
        name: 'Partner',
        value: 'Partner',
    },
]

interface IParentInfoForm {
    control: any
    errors: any
    watch?: any
    reset?: any
    setValue?: any
    onSubmitParentForm?: any
    getFormData?: any
    getStates?: any
    getCities?: any
    states?: []
    cities?: []
    parentArray?: any
    getDynamicCity?: (index?: number, params?: ICommonQuery) => void
    dynamicCities?: MCity[]
    detail?: any
    title: string
    addBtnTitle: string
    clearDynamicCities?: (index: number, deleted?: boolean) => void
}

function ParentInfoForm(props: IParentInfoForm) {
    const {
        // onSubmitParentForm,
        // getFormData,
        control,
        errors,
        watch,
        reset,
        setValue,
        parentArray,
        getStates,
        getCities,
        states,
        cities,
        getDynamicCity,
        dynamicCities,
        detail,
        title,
        addBtnTitle,
        clearDynamicCities,
    } = props
    const ac = new AbortController()

    const watchParents = watch('parents')

    const handleFileChange = (index: number) => (file: any) => {
        setValue(`parents.${+index}.loading`, true)
        CommonService.uploadImage(file)
            .then((response: any) => {
                // setImageUrl(response?.url)
                // setValue('profileImageId', response?.id)
                // setValue('profileImage', response?.url)
                const imageFile: any = {
                    fileId: response?.id,
                    sequence: index,
                    fileUrl: response?.url,
                }
                setValue(`parents.${+index}.loading`, false)
                setValue(`parents.${+index}.profileImage`, imageFile)
            })
            .catch(() => {
                setValue(`parents.${+index}.loading`, false)
            })
    }

    const onRemoveImage = (index: string) => {
        const imageFile: any = {
            fileId: '',
            sequence: index,
            fileUrl: '',
        }
        setValue(`parents.${+index}.profileImage`, imageFile)
    }

    const handleAddStorage = () => {
        if (clearDynamicCities) {
            if (watchParents?.length > 1 && dynamicCities?.length) {
                clearDynamicCities(watchParents?.length)
            } else {
                clearDynamicCities(0)
                clearDynamicCities(1)
            }
        }
        parentArray?.append({})
    }

    const handleDeleteStorage = (index: number) => {
        if (clearDynamicCities) clearDynamicCities(index, true)
        parentArray.remove(index)
    }

    useEffect(() => {
        getStates()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    return (
        <div>
            <div className="position-relative">
                <p className="educator-headline">{title}</p>
                <button
                    type="button"
                    className="page-right-headline educator-secondary-btn"
                    onClick={handleAddStorage}
                    style={{ width: '220px' }}
                >
                    {addBtnTitle}
                </button>
            </div>
            {parentArray?.fields?.map((parent: any, index: any) => {
                return (
                    <React.Fragment key={parent?.id}>
                        <Grid container spacing={2}>
                            <Grid item sm={3}>
                                <UploadImage
                                    className={clsx(
                                        'w-100 mb-2',
                                        errors?.profileImage && true
                                            ? 'border-danger'
                                            : ''
                                    )}
                                    style={{ height: 174 }}
                                    fileChanged={handleFileChange(index)}
                                    imageUrl={
                                        watchParents?.[index]?.profileImage
                                            ?.fileUrl
                                    }
                                    isLoading={watchParents?.[index]?.loading}
                                    type="upload-profile"
                                    id={`upload-image-${index}`}
                                    remove
                                    removeAction={() => onRemoveImage(index)}
                                />
                            </Grid>
                            <Grid item sm={9} container spacing={1}>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.firstName`}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="First Name"
                                                className="reddit-input w-100"
                                                variant="filled"
                                                error={
                                                    errors?.parents?.[index] &&
                                                    true
                                                }
                                                helperText={FormService.getErrorMessage(
                                                    errors?.parents?.[index],
                                                    'firstName',
                                                    'First Name'
                                                )}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.middleName`}
                                        defaultValue=""
                                        // rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Middle Name"
                                                className="reddit-input w-100"
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.lastName`}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Last Name"
                                                className="reddit-input w-100"
                                                variant="filled"
                                                error={
                                                    errors?.parents?.[index]
                                                        ?.lastName && true
                                                }
                                                helperText={FormService.getErrorMessage(
                                                    errors?.parents?.[index],
                                                    'lastName',
                                                    'Last Name'
                                                )}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    {/* <Controller
                                        control={control}
                                        name={`parents.${index}.contactNumber`}
                                        defaultValue=""
                                        rules={{ maxLength: 10 }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Contact Number"
                                                className="reddit-input w-100"
                                                variant="filled"
                                                helperText={FormService.getErrorMessage(
                                                    errors?.parents?.[index],
                                                    'contactNumber',
                                                    'Contact Number should contain 10 characters'
                                                )}
                                            />
                                        )}
                                    /> */}
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.contactNumber`}
                                        defaultValue=""
                                        rules={{ minLength: 12 }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...fields
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...fields}
                                                inputRef={ref}
                                                label="Contact Number"
                                                variant="filled"
                                                className="reddit-input w-100"
                                                error={
                                                    errors?.parents?.[index]
                                                        ?.contactNumber && true
                                                }
                                                helperText={FormService.getErrorMessage(
                                                    errors?.parents?.[index],
                                                    'contactNumber',
                                                    'Contact Number'
                                                )}
                                                onKeyPress={
                                                    CommonService.phoneNumber
                                                }
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.relationship`}
                                        defaultValue=""
                                        // rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <BaseSelect
                                                options={relationshipOptions}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Relationship"
                                                className="reddit-input w-100"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={6}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.address`}
                                        defaultValue=""
                                        // rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Addrress"
                                                className="reddit-input w-100"
                                                variant="filled"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.state`}
                                        defaultValue=""
                                        // rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <BaseCreatableSelect
                                                value={value}
                                                onChange={(event: any) => {
                                                    const parentCode = event

                                                    onChange(event)
                                                    setValue(
                                                        `parents.${index}.city`,
                                                        ''
                                                    )
                                                    if (getDynamicCity)
                                                        getDynamicCity(index, {
                                                            parentCode,
                                                        })
                                                }}
                                                options={states}
                                                label="State"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.city`}
                                        defaultValue=""
                                        // rules={{ required: true }}
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <BaseCreatableSelect
                                                value={value}
                                                onChange={onChange}
                                                // options={cities}
                                                options={
                                                    dynamicCities
                                                        ? (dynamicCities[
                                                              index
                                                          ] as any)
                                                        : []
                                                }
                                                label="City"
                                                fullWidth
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item sm={3}>
                                    {/* <Controller
                                        control={control}
                                        name={`parents.${index}.zipCode`}
                                        defaultValue=""
                                        render={({
                                            field: {
                                                ref,
                                                value,
                                                onChange,
                                                ...field
                                            },
                                        }: any) => (
                                            <RedditTextField
                                                {...field}
                                                value={value}
                                                onChange={onChange}
                                                inputRef={ref}
                                                label="Zip Code"
                                                className="reddit-input w-100"
                                                variant="filled"
                                            />
                                        )}
                                    /> */}
                                    <Controller
                                        control={control}
                                        name={`parents.${index}.zipCode`}
                                        defaultValue=""
                                        rules={{ minLength: 5 }}
                                        render={({
                                            field: { ref, value, onChange },
                                        }: any) => (
                                            <InputMask
                                                mask="99999"
                                                value={value}
                                                onChange={(
                                                    e: ChangeEvent<any>
                                                ) => {
                                                    const validatedValue =
                                                        e?.target?.value
                                                    onChange(
                                                        validatedValue?.replaceAll(
                                                            '_',
                                                            ''
                                                        )
                                                    )
                                                }}
                                                className="reddit-input w-100"
                                            >
                                                {(inputProps: any) => {
                                                    return (
                                                        <RedditTextField
                                                            {...inputProps}
                                                            inputRef={ref}
                                                            label="Zip Code"
                                                            variant="filled"
                                                            error={
                                                                errors
                                                                    ?.parents?.[
                                                                    index
                                                                ]?.zipCode &&
                                                                true
                                                            }
                                                            helperText={FormService.getErrorMessage(
                                                                errors
                                                                    ?.parents?.[
                                                                    index
                                                                ],
                                                                'zipCode',
                                                                'Zip Code',
                                                                'Zip Code should be 5 digit'
                                                            )}
                                                        />
                                                    )
                                                }}
                                            </InputMask>
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {parentArray?.fields?.length !== 1 && (
                            <div className="text-right">
                                <span
                                    className="page-delete-btn"
                                    onClick={() => handleDeleteStorage(index)}
                                >
                                    Remove
                                </span>
                            </div>
                        )}
                        {!(parentArray?.fields?.length - 1 === +index) && (
                            <div className="page-hr my-3" />
                        )}
                    </React.Fragment>
                )
            })}
        </div>
    )
}

const mapStateToProps = (store: any) => {
    const { dynamicCities } = store?.educator?.educatorInfo

    return {
        states: store?.educator?.educatorInfo?.parentStates.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        cities: store?.educator?.educatorInfo?.parentCities.map((item: any) => {
            return {
                id: item.id,
                name: item.name,
                value: item.code,
            }
        }),
        dynamicCities,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getDynamicCity, clearDynamicCities } = EducatorInfoActions
    return {
        getStates: () =>
            dispatch(
                RegroundAction.getReground(
                    'STATE',
                    EducatorActionTypes.GET_PARENT_STATES
                ) as any
            ),
        getCities: (params: any) =>
            dispatch(
                RegroundAction.getReground(
                    'CITY',
                    EducatorActionTypes.GET_PARENT_CITIES,
                    params
                ) as any
            ),
        getDynamicCity: (index?: number, params?: ICommonQuery) =>
            dispatch(getDynamicCity(index, params) as any),
        clearDynamicCities: (index: number, deleted?: boolean) =>
            dispatch(clearDynamicCities(index, deleted) as any),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ParentInfoForm)
